import { DELETE, VIEW } from '@/helpers/enums/table-actions'

export const TABLE_ACTIONS = Object.freeze([
  VIEW,
  DELETE,
])

export const TABLE_HEADERS = Object.freeze([
  {
    text: 'ID',
    value: 'lk_publication_id',
    sortable: true,
    width: '90px',
  },
  {
    text: 'Наименование',
    value: 'name',
    sortable: false,
  },
])
